/**
 * Seeding query key factory
 */
export const seedingKeys = {
  all: ["seeding"] as const,
  modules: () => [...seedingKeys.all, "modules"] as const,
  variables: (modules: string[]) =>
    [...seedingKeys.all, "variables", modules] as const,
} as const;
